export default "__VITE_ASSET__BvKA$iID__"